// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.page-layout{display:flex;flex-direction:column;justify-content:flex-start;flex:1 0 100%}.page-layout>*:last-child{margin-top:auto}`, "",{"version":3,"sources":["webpack://./src/components/wrappers/PageLayout/PageLayout.scss"],"names":[],"mappings":"AAAA,aACI,YAAA,CACA,qBAAA,CACA,0BAAA,CACA,aAAA,CAEA,0BACI,eAAA","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
